import { useField } from "formik";
import { CountrySelect } from "../patterns/address-form/CountrySelect";

interface CountrySelectFormikFieldProps {
  name: string;
  label: string;
  isRequired?: boolean;
  testID?: string;
  isDisabled?: boolean;
  description?: string;
  info?: React.ReactNode;
}

/**
 * Formik-compatible wrapper around the CountrySelect component.
 */
export function CountrySelectFormikField({
  name,
  label,
  isRequired,
  testID = "country-select",
  isDisabled,
  description,
  info,
}: CountrySelectFormikFieldProps) {
  const [field, meta, helpers] = useField(name);

  return (
    <CountrySelect
      label={label}
      isRequired={isRequired}
      testID={testID}
      selectedKey={field.value}
      onChange={(key: string) => helpers.setValue(key)}
      onBlur={field.onBlur}
      isDisabled={isDisabled}
      description={description}
      info={info}
      errors={meta.touched && meta.error ? meta.error : undefined}
      isInvalid={meta.touched && !!meta.error}
    />
  );
}
